import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appAlphaNumeric]',
})
export class AlphaNumericDirective {
  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('input', ['$event']) onInput(event: Event): void {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const inputValue: string = inputElement.value;
    const alphaNumericValue = inputValue.replace(/[^a-zA-Z0-9\s]/g, '');

    // Update both DOM and form control value
    inputElement.value = alphaNumericValue;
    if (this.control?.control) {
      this.control.control.setValue(alphaNumericValue, { emitEvent: false });
    }
  }
}

//     @HostListener('input', ['$event']) onInput(event: Event): void {
//         const inputElement = this.el.nativeElement as HTMLInputElement;
//         const inputValue: string = inputElement.value;
//         // Allow only alphabetic and numeric characters, removing special characters
//         const alphaNumericValue = inputValue.replace(/[^a-zA-Z0-9\s]/g, '');
//         inputElement.value = alphaNumericValue;
//     }
